import { NamedUrl } from '../types';
import { RouteDictionary } from './RouteDictionary';

export const mainRoutes: Array<NamedUrl> = [
  {
    name: RouteDictionary.INDEX,
    url: '/',
  },
  {
    name: RouteDictionary.RULES_SERVICE,
    url: '/rules_service',
  },
  {
    name: RouteDictionary.PERSONAL_DATA_POLICY,
    url: '/personal_data_policy',
  },
  {
    name: RouteDictionary.RULES_REGISTRATION,
    url: '/rules_registration',
  },
  {
    name: RouteDictionary.FAQ,
    url: '/how-it-works/faq',
  },
  {
    name: RouteDictionary.PLATFORM,
    url: '/platform',
  },
  {
    name: RouteDictionary.ABOUT_US,
    url: '/about-us',
  },
  {
    name: RouteDictionary.NEWS,
    url: '/news',
  },
  {
    name: RouteDictionary.HOW_IT_WORKS_NAVIGATION,
    url: '/how-it-works',
  },
  {
    name: RouteDictionary.HOW_IT_WORKS,
    url: '/how-it-works',
  },
  {
    name: RouteDictionary.ENTER,
    url: '/enter',
  },
  {
    name: RouteDictionary.FORGOT_PASSWORD,
    url: '/forgot-password',
  },
  {
    name: RouteDictionary.NOT_FOUND,
    url: '*',
  },
];
